import React, { useState, useEffect } from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './LatestArticles.css';

const LatestArticles = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [newsItems, setNewsItems] = useState([]);
  const [articleData, setArticleData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await fetch('http://localhost:3001/api/articles?status=published');
      const data = await response.json();
      
      // Get news items (limit to 5)
      const news = data.filter(item => item.category === 'news' || item.category === 'announcements').slice(0, 5);
      setNewsItems(news);
      
      // Get featured article (first general/community article)
      const featured = data.find(item => item.category === 'general' || item.category === 'community');
      if (featured) {
        setArticleData({
          date: new Date(featured.createdAt).toLocaleDateString('en-US', { day: '2-digit', month: 'short' }),
          author: featured.author,
          title: featured.title,
          content: featured.content,
          image: featured.featuredImage
        });
      }
    } catch (error) {
      console.error('Failed to fetch articles:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="latest-articles" id="articles">
        <div className="articles-blur"></div>
        <div className="section-title-wrapper">
          <h2 className="section-title">Latest Articles</h2>
        </div>
        <p style={{ textAlign: 'center', padding: '3rem', color: '#666' }}>Loading articles...</p>
      </section>
    );
  }

  if (!articleData && newsItems.length === 0) {
    return (
      <section className="latest-articles" id="articles">
        <div className="articles-blur"></div>
        <div className="section-title-wrapper">
          <h2 className="section-title">Latest Articles</h2>
        </div>
        <p style={{ textAlign: 'center', padding: '3rem', color: '#666' }}>No articles available yet.</p>
      </section>
    );
  }

  return (
    <section className="latest-articles" id="articles">
      {/* Decorative blur */}
      <div className="articles-blur"></div>

      <div className="section-title-wrapper">
        <h2 className="section-title">Latest Articles</h2>
      </div>

      <div className="articles-layout">
        {/* Main Article */}
        {articleData && (
          <div className="main-article">
            <div className="article-image">
              <img
                src={articleData.image || "/Sndp/567575675756-1280x720.jpg"}
                alt="Article featured"
              />
            </div>

            <div className="article-body">
              <div className="article-meta">
                <div className="article-date">
                  <span>{articleData.date}</span>
                </div>
                <div className="article-author">
                  <span>By {articleData.author}</span>
                </div>
              </div>

              <h3 className="article-title">{articleData.title}</h3>

              <div className="article-content-scroll">
                <p className="article-text">{articleData.content}</p>
              </div>
            </div>
          </div>
        )}

        {/* News Sidebar */}
        {newsItems.length > 0 && (
          <div className="news-sidebar">
            <div className="news-sidebar-header">
              <h3>Latest News & Updates</h3>
            </div>
            <div className="news-sidebar-list">
              {newsItems.map((item) => (
                <div key={item.id} className="news-item">
                  <div className="news-item-text">
                    <h4 className="news-item-title">{item.title}</h4>
                    <p className="news-item-desc">{item.content.substring(0, 100)}...</p>
                  </div>
                  <div className="news-item-image">
                    <img
                      src={item.featuredImage || "/Sndp/logo.png"}
                      alt={item.title}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Divider line */}
      <div className="articles-divider"></div>

      {/* Pagination */}
      <div className="articles-pagination">
        <button
          className="pagination-btn prev"
          onClick={() => setCurrentPage(Math.max(0, currentPage - 1))}
        >
          <FiChevronLeft size={40} color="#444" />
        </button>

        <div className="pagination-dots">
          {[0, 1, 2, 3, 4].map((i) => (
            <span
              key={i}
              className={`dot ${i === currentPage ? 'active' : ''}`}
              onClick={() => setCurrentPage(i)}
            ></span>
          ))}
        </div>

        <button
          className="pagination-btn next"
          onClick={() => setCurrentPage(Math.min(4, currentPage + 1))}
        >
          <FiChevronRight size={40} color="#444" />
        </button>
      </div>
    </section>
  );
};

export default LatestArticles;
